// TC-S2 — shared calendar helpers reused by TeamCalendarOverviewPage
// and ConsultantTimesheetPanel. All local-calendar only; no
// toISOString / UTC conversions anywhere (per spec §Do NOT change).

export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];
export const DOW_ABBR = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const DOW_FULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const pad2 = (n) => String(n).padStart(2, '0');

// "yyyy-MM-dd" from a Date's LOCAL fields. Never call toISOString here
// — the ISO variant would round to UTC and slip a day for anything
// west of the meridian.
export const fmtIso = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

export const parseIso = (s) => {
  const [y, m, dd] = s.split('-').map(Number);
  return new Date(y, m - 1, dd);
};

export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

// Monday-based ISO week (matches MyTimesheetPage).
export const mondayOf = (d) => addDays(d, -(((d.getDay() + 6) % 7)));

export const isWeekend = (d) => { const w = d.getDay(); return w === 0 || w === 6; };
export const firstOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
export const lastOfMonth = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0);

export const fmtDdMm = (d) => `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}`;
export const fmtDdMmYy = (d) => `${fmtDdMm(d)}.${String(d.getFullYear()).slice(2)}`;

export const fmtHours = (v) => {
  const n = Number(v) || 0;
  if (n === 0) return '0';
  return n % 1 === 0 ? String(n) : n.toFixed(1);
};

export function periodLabel(view, anchor) {
  if (view === 'm') return `${MONTH_NAMES[anchor.getMonth()]} ${anchor.getFullYear()}`;
  if (view === 'w') {
    const mon = mondayOf(anchor);
    const fri = addDays(mon, 4);
    return `${fmtDdMm(mon)} – ${fmtDdMmYy(fri)}`;
  }
  return `${DOW_FULL[anchor.getDay()]}, ${fmtDdMmYy(anchor)}`;
}

// Both TeamCalendarOverviewPage (month view over the team) and
// ConsultantTimesheetPanel share this: month → 1st..last; week →
// Mon..Fri; day → same date on both ends.
export function rangeOf(view, anchor) {
  if (view === 'm') return { from: firstOfMonth(anchor), to: lastOfMonth(anchor) };
  if (view === 'w') {
    const mon = mondayOf(anchor);
    return { from: mon, to: addDays(mon, 4) };
  }
  return { from: anchor, to: anchor };
}

export function navStep(view, anchor, dir) {
  if (view === 'm') return new Date(anchor.getFullYear(), anchor.getMonth() + dir, 1);
  if (view === 'w') return addDays(anchor, 7 * dir);
  return addDays(anchor, dir);
}

// Combination colour class for the month cell. When two or more of
// (billable, non-billable, leave) are > 0 → mix (#e7ddf3). Otherwise
// pick the single non-zero column's colour. A full-day leave day
// (Type = PaidLeave / SickLeave) is always the leave colour even if
// leaveHours arrived from LeaveHours on the server-side.
export function combinationClass(day) {
  const b = Number(day.billableHours) || 0;
  const n = Number(day.nonBillableHours) || 0;
  const l = Number(day.leaveHours) || 0;
  if (day.type === 'PaidLeave' || day.type === 'SickLeave') return 'tc-lv';
  const nonZero = (b > 0 ? 1 : 0) + (n > 0 ? 1 : 0) + (l > 0 ? 1 : 0);
  if (nonZero === 0) return '';
  if (nonZero > 1) return 'tc-mix';
  if (b > 0) return 'tc-b';
  if (n > 0) return 'tc-nb';
  return 'tc-lv';
}
